import DocumentModel from "../models/document";
import { fetchClubsByUser, fetchDocuments } from "../provider/api";
import { endpoint } from "../../utils/constants";
import ClubsUserModel from "../models/clubsUser";

export async function getDocuments(prefix: string): Promise<{
  documents: DocumentModel[];
  total: number;
}> {
  try {
    const responseData = await fetchDocuments(prefix);

    if (responseData.statusCode && responseData.statusCode !== 200) {
      throw new Error(responseData.message || "Erro ao buscar documentos.");
    }

    const documentsWithFullUrls = (responseData.files || []).map(
      (file: any) => {
        const isHttpUrl = (url: string) => {
          return url.startsWith('http://') || url.startsWith('https://');
        };

        const normalizeUrl = (url: string | null | undefined) => {
          if (!url) return null;
          
          if (isHttpUrl(url)) {
            return url;
          }
          
          const uploadMatch = url.match(/[/\\]upload[-_]?documents?[/\\](.+)$/i);
          if (uploadMatch) {
            const filename = uploadMatch[1].replace(/\\/g, '/');
            return `${endpoint}/upload/documents/${filename}`;
          }
          
          if (/^[a-zA-Z]:[\\]/.test(url) || /^[a-zA-Z]:\//.test(url) || url.startsWith('/home/') || url.startsWith('/var/')) {
            return null;
          }
          
          const relativePath = url.startsWith('/') ? url : `/${url}`;
          return `${endpoint}${relativePath}`;
        };

        const normalizedUrl = normalizeUrl(file.url);
        const normalizedDownloadUrl = normalizeUrl(file.downloadUrl);

        return {
          ...file,
          url: normalizedUrl,
          downloadUrl: normalizedDownloadUrl,
          physicalPath: undefined,
        };
      }
    );

    const documents = DocumentModel.fromApiResponseArray(documentsWithFullUrls);
    const total = responseData.total || 0;

    return { documents, total };
  } catch (error: any) {
    console.error(`Erro (${error.response?.status}) ao buscar documentos`);
    return { documents: [], total: 0 };
  }
}

export function filterDocumentsByName(
  documents: DocumentModel[],
  searchTerm: string
): DocumentModel[] {
  if (!searchTerm.trim()) {
    return documents;
  }

  return documents.filter((doc) =>
    doc.filename?.toLowerCase().includes(searchTerm.toLowerCase())
  );
}

export async function getClubsByUser(): Promise<{ clubs: ClubsUserModel[] }> {
    try {
        const responseData = await fetchClubsByUser();

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar clubes.");
        }

        const clubs = ClubsUserModel.fromApiResponseArray(responseData);
        

        return { clubs };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar clubes`);
        console.log(error.toString());
        return { clubs: []};
    }
}
